import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, Typography } from '@mui/material';

import type { CMS1500FormData } from '../ClaimCMS1500Form';
import { ClaimTextField } from '../fields';

export const Box15_OtherDate: React.FC = () => {
  const { control } = useFormContext<CMS1500FormData>();
  return (
    <>
      <Typography variant="caption">15. OTHER DATE</Typography>
      <Box display="flex" gap={1}>
        <Controller
          name="otherDate"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              type="date"
              size="small"
              fullWidth
            />
          )}
        />
        <Controller
          name="otherDateQualifier"
          control={control}
          render={({ field, fieldState }) => (
            <ClaimTextField
              field={field}
              fieldState={fieldState}
              size="small"
              placeholder="Qual"
              disabled
              sx={{ width: '80px' }}
            />
          )}
        />
      </Box>
    </>
  );
};